(function () {

  function promoPopup() {
    const modalWindowSubscribe = document.querySelector(".promo-popup-subscribe");
    const promoSubmitButton = document.querySelector(".promo-popup-form-submit");
    const buttonCloseSubscribe = document.querySelector(".promo-popup-close-subscribe");

    const modalWindowPromo = document.querySelector(".promo-popup-promo");
    const buttonClosePromo = document.querySelector(".promo-popup-close-promo");

    const promoFormSubmitedShowTimes = document.querySelector(".promo-popup-wrap").dataset.popupTimes;
    const promoFormSubmitedShowTimeout = document.querySelector(".promo-popup-wrap").dataset.popupTimeout;
    const promoPopupHideForDayKey = 'promoPopupHideForDayUntil';
    const promoPopupHideForDayDuration = 24 * 60 * 60 * 1000;

    let promoFormSubmitedTimes = parseInt(localStorage.getItem('counter') || 0, 10);
    let promoFormSubmited = localStorage.getItem('formSubmited') || false;
    let promoSubmitButtonClicked = localStorage.getItem('promoSubmitButtonPosition') || false;
    let promoPopupHideForDayUntil = parseInt(localStorage.getItem(promoPopupHideForDayKey) || 0, 10);

    const currentURL = window.location.href;
    const containsChallenge = currentURL.includes('challenge');
    const containsPosted = currentURL.includes('customer_posted=true');
    const now = Date.now();

    if (promoPopupHideForDayUntil && promoPopupHideForDayUntil <= now) {
      localStorage.removeItem(promoPopupHideForDayKey);
      localStorage.setItem('counter', 0);
      promoFormSubmitedTimes = 0;
      localStorage.setItem('formSubmited', false);
      promoFormSubmited = 'false';
      localStorage.setItem('promoSubmitButtonPosition', false);
      promoSubmitButtonClicked = 'false';
      promoPopupHideForDayUntil = 0;
    }

    const shouldShowSuccess = modalWindowPromo.classList.contains('promo-popup-success') && promoFormSubmited == "false" && promoSubmitButtonClicked == "true";
    const shouldHidePopupForDay = promoPopupHideForDayUntil > now;

    if (shouldShowSuccess) {
      modalWindowPromo.style.visibility = 'visible';
      modalWindowPromo.classList.add('active');
      document.querySelector("body").classList.add('overflow-hidden');

      localStorage.setItem('formSubmited', true);
      localStorage.setItem(promoPopupHideForDayKey, now + promoPopupHideForDayDuration);

    } else if (shouldHidePopupForDay == false && parseInt(promoFormSubmitedTimes, 10) < parseInt(promoFormSubmitedShowTimes, 10) && containsChallenge == false && containsPosted == false) {
      setTimeout(() => {
        modalWindowSubscribe.style.visibility = 'visible';
        modalWindowSubscribe.classList.add('active');
        document.querySelector("body").classList.add('overflow-hidden');
        localStorage.setItem('formSubmited', false);
        localStorage.setItem('counter', ++promoFormSubmitedTimes);

        const emailInput = modalWindowSubscribe.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.focus();
        }

        promoSubmitButton.addEventListener('click', function (event) {
          localStorage.setItem('promoSubmitButtonPosition', true);
        });

      }, promoFormSubmitedShowTimeout * 1000);

    }

    buttonCloseSubscribe.addEventListener('click', function (event) {
      modalWindowSubscribe.style.visibility = 'hidden';
      modalWindowSubscribe.classList.remove('active');
      document.querySelector("body").classList.remove('overflow-hidden');
    });

    buttonClosePromo.addEventListener('click', function (event) {
      modalWindowPromo.style.visibility = 'hidden';
      modalWindowPromo.classList.remove('active');
      document.querySelector("body").classList.remove('overflow-hidden');
    });

    buttonCloseSubscribe.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        modalWindowSubscribe.style.visibility = 'hidden';
        modalWindowSubscribe.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });
    
    buttonClosePromo.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        modalWindowPromo.style.visibility = 'hidden';
        modalWindowPromo.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        if (modalWindowSubscribe.classList.contains('active')) {
          modalWindowSubscribe.style.visibility = 'hidden';
          modalWindowSubscribe.classList.remove('active');
        }
    
        if (modalWindowPromo.classList.contains('active')) {
          modalWindowPromo.style.visibility = 'hidden';
          modalWindowPromo.classList.remove('active');
        }
    
        document.body.classList.remove('overflow-hidden');
      }
    });

    const modalWindowSubscribeClose = modalWindowSubscribe.querySelector(".overlay");
    if (modalWindowSubscribeClose) {
      modalWindowSubscribeClose.addEventListener('click', function (event) {
        if (modalWindowSubscribe.classList.contains('active')) {
          modalWindowSubscribe.style.visibility = 'hidden';
          modalWindowSubscribe.classList.remove('active');
          document.querySelector("body").classList.remove('overflow-hidden');
        }
      });
    }

    const modalWindowPromoClose = modalWindowPromo.querySelector(".overlay");
    if (modalWindowPromoClose) {
      modalWindowPromoClose.addEventListener('click', function (event) {
        if (modalWindowPromo.classList.contains('active')) {
          modalWindowPromo.style.visibility = 'hidden';
          modalWindowPromo.classList.remove('active');
          document.querySelector("body").classList.remove('overflow-hidden');
        }
      });
    }

    const copyCode = document.querySelector('.promo-popup-promo button');
    copyCode.addEventListener('click', function (event) {
      const buttonText = document.querySelector('.promo-popup-promo button span');
      let copyText = document.getElementById("copyPromoCode");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
      copyText.classList.add('copied');

      const originalText = buttonText.textContent;
      buttonText.textContent = "Copied"

      setTimeout(() => {
        buttonText.textContent = originalText;
        copyText.classList.remove('copied');
      }, 3000)
      
      
    });
  }

  document.addEventListener('DOMContentLoaded', promoPopup);
  document.addEventListener('shopify:section:load', promoPopup);

})();